import {
    APPLE_QUERY_PARAM,
    FACEBOOK_HASH,
} from '@/lib/consts/auth';
import { resolveOtpCredentials } from '@/lib/auth/otpHandoff';
import { getHashParam, getUrlQueryParam } from './url';

export const EOTPTextModel = {
    SIX_DIGITS: 'sixDigits',
    FOUR_DIGITS: 'fourDigits',
    MOBILE_ONLY: 'mobileOnly',
} as const;

export const isFacebookLogin = (): boolean => {
    return getHashParam(FACEBOOK_HASH) !== null;
};

export const isAppleLogin = (): boolean => {
    return getUrlQueryParam(APPLE_QUERY_PARAM) === 'true';
};

/**
 * `/login/otp?proofKey=<code>` is an OTP auto-login callback. The token is
 * optional: store-frontend logs in with playerCode alone when it is absent.
 * When a token is present (query param or pre-jump stash) it is sent alongside.
 */
export const isOTPLogin = (): boolean => {
    return resolveOtpCredentials() !== null;
};

export const shouldShowOtpButton = ({
    otpOn,
    otpTextModel,
    mobileOnlyOtpFF,
    isDesktopDevice,
}: {
    otpOn: boolean;
    otpTextModel?: string;
    mobileOnlyOtpFF: boolean;
    isDesktopDevice: boolean;
}): boolean => {
    if (!otpOn) return false;

    if (mobileOnlyOtpFF) {
        return !isDesktopDevice;
    }

    return isDesktopDevice
        ? !!otpTextModel && otpTextModel !== EOTPTextModel.MOBILE_ONLY
        : true;
};
